import { Component } from '@angular/core';

import { IPiwikConfig, LibConfig } from './lib.config';

@Component({
    selector: 'ba-piwik',
    template: '',
})
export class PiwikScriptComponent {
    private _config: IPiwikConfig = this.libconfig.getPiwikConfig();

    constructor(private libconfig: LibConfig) {
        // -- Abbrechen, falls PIWIK nicht freigeschalten ist
        if (!this._config.trackingActivated) {
            return;
        }
        this._insertPiwikScript();
    }

    /**
     * Fuegt das PiwikScript Element am Ende vom body Tag ein.
     */
    _insertPiwikScript(): void {
        // -- Abbrechen, falls script bereits im document existiert
        if (this._scriptExisits(this._config.scriptSrc)) {
            return;
        }
        // -- Script erzeugen
        const piwikScriptElement = document.createElement('script');
        piwikScriptElement.type = 'text/javascript';
        piwikScriptElement.async = true;
        piwikScriptElement.defer = true;
        piwikScriptElement.src = this._config.scriptSrc;

        // -- Am Ende vom Body einfügen
        document.body.appendChild(piwikScriptElement);
    }

    /**
     * Prüft ob ein Script-Tag mit der "url" bereits im DOM existiert
     * @param url
     */
    _scriptExisits(url: string): boolean {
        return document.querySelectorAll(`script[src="${url}"]`).length > 0;
    }
}
